import { useEffect, useState, useRef } from 'react'
import { useQuery } from 'react-query'

import { getResourceList } from '../../models/BaseModel'

import { ImageReplacementAnchor, InlineNavigation, Loading, LogoNavigation, DrawerNavigation, BlankErrorBoundary } from '@scrippsproduct/networks-ui-library'

import './../../scss/Header.scss'

import laffLogo from './../../images/laff-logo.svg'

export default function Header() {
    const [menuLinks, setMenuLinks] = useState([])
    const [logoItems, setLogoItems] = useState([])
    const {isLoading, isSuccess, data} = useQuery(['header', {resourceName: 'header'}], getResourceList)
    const sentinelRef = useRef()

    useEffect(() => {
        if (isSuccess) {
            setMenuLinks(data.get('menuLinks'))
            setLogoItems(data.get('logoItems'))
        }
    }, [isSuccess, data])

    useEffect(() => {
        if (!sentinelRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                // When sentinel is visible (at top), remove scrolled class
                // When sentinel is not visible (scrolled past), add scrolled class
                document.documentElement.classList.toggle('scrolled', !entry.isIntersecting);
            },
            { 
                threshold: 0,
                rootMargin: '0px 0px 0px 0px'
            }
        );

        observer.observe(sentinelRef.current);

        return () => {
            observer.disconnect();
            document.documentElement.classList.remove('scrolled');
        };
    }, []);
    
    return (<>
        {/* Sentinel element to detect scroll position */}
        <div ref={sentinelRef} className="scroll-sentinel" />
        <header>
            <content-constrainer class="desktop-nav">
                <ImageReplacementAnchor href={`/`} 
                    image={{
                        url: laffLogo,
                        width: 380, 
                        height: 250,
                        altText: 'Laff logo, go to home page',
                    }} 
                    height={4.8}
                    baselineAdjustment={0.8}
                />
                { (isLoading) && <Loading />}
                <header-menu-wrapper>
                    { (isSuccess && menuLinks.length > 0) && 
                        <BlankErrorBoundary>
                            <InlineNavigation 
                                links={menuLinks} 
                                classname="main-navigation" 
                                position='right'
                            />
                        </BlankErrorBoundary>
                    } 
                    { (isSuccess && logoItems?.length > 0) && 
                        <LogoNavigation 
                            items={logoItems}
                        />
                    }
                </header-menu-wrapper>
            </content-constrainer>
            <nav className="mobile-nav">
                <content-constrainer class="content-constrainer--no-border">
                    <BlankErrorBoundary>
                        { (isSuccess && menuLinks.length > 0 && logoItems?.length > 0) && 
                            <DrawerNavigation
                                links={[
                                    {
                                        type: 'internal-link',
                                        href: '/',
                                        label: 'Home',
                                    },
                                    ...menuLinks]} 
                                items={logoItems}
                                logo={{
                                    image: {
                                        url: laffLogo, 
                                        width: 380, 
                                        height: 250,
                                        altText: 'Laff logo, go to home page',
                                    },
                                    href: `/`,
                                    height: 3.3,
                                    baselineAdjustment: 0.1
                                }}
                                classname="main-navigation"
                                clipPathStart="polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"
                                clipPathEnd="polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
                                overlayAppendEl={document.querySelector('site-wrapper')}
                            /> 
                        }
                    </BlankErrorBoundary>
                </content-constrainer>
            </nav>
        </header>
    </>)
}
